import { useState } from 'react';
import { getInformeDesg } from '../services/informeDesg';
import { InformeSegDesDto } from '../models/informeDesg';

const useInformeDesg = () => {
    const [data, setData] = useState<InformeSegDesDto[]>([]);

    const obtenerInformeDesg = async (tipoSeguro: string, rutCompania: string, codigoPoliza: string, fechaRemesa: Date) => {
        const response = await getInformeDesg(tipoSeguro, rutCompania, codigoPoliza, fechaRemesa);
        if (response.status !== 200)
            return;

        setData(response.data.result);
    }

    return { data, obtenerInformeDesg,setData };
};

export default useInformeDesg;